import { useBaseViewModel } from '@/common';
import { BusinessUnitList } from '@/domains/business-unit/entities';
import { GetListBusinessUnitUsecase } from '@/domains/business-unit/usecases/get-list.usecase';
import { useState } from 'react';
import { QueryBusinessUnitPayload } from '@/domains/business-unit/ports/payloads';
import { BusinessUnitHttpRepository } from '../adapters/repositories/business-unit.http.repository';

export default function GetListBusinessUnit() {
  const getListBusinessUnitUC = new GetListBusinessUnitUsecase(new BusinessUnitHttpRepository());
  const { loading, error, catchAction } = useBaseViewModel();
  const [businessUnitData, setBusinessUnitData] = useState<BusinessUnitList>();

  const actionGetListBU = async (payload?: QueryBusinessUnitPayload) => {
    await catchAction(async () => {
      const data = await getListBusinessUnitUC.run(payload);
      setBusinessUnitData(data);
    });
  };

  return {
    loading,
    error,
    businessUnitData,
    actionGetListBU,
  };
}
